import styled from 'styled-components';
import { layout, responsiveBreakPoints, spacings } from '@styles/DesignVariables';
const { maxTablet } = responsiveBreakPoints;
export const Container = styled.div`
	max-width: ${layout.maxContentWidth};
	width: 100%;
	margin: 0 auto;
	padding: 0 16px;
	@media only screen and ${maxTablet} {
		padding: ${spacings.s12} ${spacings.s16};
	}
`;

export const HeaderContainer = styled.div`
	max-width: ${layout.maxContentWidth};
	width: 100%;
	margin: 0 auto;
	padding: 0 16px;
	@media only screen and ${maxTablet} {
		padding: ${spacings.s8} ${spacings.s16};
	}
`;

export const ArticleContainer = styled.div`
	max-width: ${layout.maxContentWidth};
	display: flex;
	gap: 32px;
	padding: 40px 16px 64px 16px;
	position: relative;
	width: 100%;
	margin: 0 auto;
	@media only screen and ${maxTablet} {
		padding: ${spacings.s40} ${spacings.s16};
		display: block;
	}
`;
